import { useRequest } from "../../utils/api"
import { GeneralProps } from "../../utils/api.type"
import { ListUsersResponse } from "./user.type"

const ENDPOINT_LIST_USERS = '/v1/rms/config/list-users/'
export const useConfigListUsers = (obj = {} as GeneralProps) => {
  return useRequest<ListUsersResponse>(ENDPOINT_LIST_USERS, {},
  {
    enabled: obj.enabled,
    cacheKey: JSON.stringify(obj),
  })
}